import { useLayoutEffect, useState } from 'react';

export function useLazyModalOpenState(isOpen: boolean) {
	const [shouldRender, setShouldRender] = useState(false);

	useLayoutEffect(() => {
		if (isOpen) {
			setShouldRender(true);
		}
	}, [isOpen]);

	return { shouldRender };
}
